import(/* webpackMode: "eager" */ "/codebuild/output/src755878744/src/bacha-ai-frontend/app/case-studies/page.tsx");
